<template>
    <div class="card">
            <section class="page-section mb-3" >
                <div class="container-fluid">
                    <div class="grid justify-content-between align-items-center">
                        <div  class="col " >
                            <div class=" flex gap-2 align-items-center " >
                                <Avatar size="large" class="" icon="pi pi-history" />
                                    <div class="text-2xl text-primary font-bold flex-1">
                                        {{ $t('historyChanges') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
        <template v-if="loading">
            <div style="min-height:100px" class="flex gap-3 justify-content-center align-items-center p-3">
                <div>
                    <ProgressSpinner style="width:50px;height:50px" />
                </div>
                <div class="text-500">{{ $t('loading') }}</div>
            </div>
        </template>
        <template v-else-if="auditData.length === 0">
            <p>{{ $t('noAuditsRecords') }}</p>
        </template>
        <template v-else>
            <Timeline :value="auditData">
                <template #marker="slotProps">
                    <span class="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1" :style="{ backgroundColor: getColor(slotProps.item.event) }">
                        <i :class="getIcon(slotProps.item.event)"></i>
                    </span>
                </template>
                <template #opposite="slotProps">
                    <small class="p-text-secondary">{{ $utils.formatDateCreatedAt(slotProps.item.created_at) }}</small>
                   
                </template>
                <template #content="slotProps">
                    <template v-if="slotProps.item.old_values?.status_id !== undefined && slotProps.item.new_values?.status_id !== undefined">
                        <small class="p-text-secondary">
                           {{ $t('change') }} {{ $t('of') }} {{ $t('status') }}: {{ getStatusText(slotProps.item.old_values.status_id) }} → {{ getStatusText(slotProps.item.new_values.status_id) }}
                        </small>
                    </template>
                    <template v-if="slotProps.item.old_values?.fk_status !== undefined && slotProps.item.new_values?.fk_status !== undefined">
                        <small class="p-text-secondary">
                            {{ $t('change') }} {{ $t('of') }} {{ $t('status') }}: {{ getStatusTextIncident(slotProps.item.old_values.fk_status) }} → {{ getStatusTextIncident(slotProps.item.new_values.fk_status) }}
                        </small>
                    </template>
                    <div class="flex items-center gap-2">
                        <span>{{ getEventText(slotProps.item.event) }} por: {{ slotProps.item.user_fullname }}</span>
                    </div>
                    <br>
                </template>
            </Timeline>
        </template>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Timeline from 'primevue/timeline';
import { ApiService } from '@/services/api';
import { $t } from '@/services/i18n';
// Props
const props = defineProps({
    auditable: {
        type: String,
        required: true,
    },
    event: {
        type: String,
    },
    auditableId: {
        type: [String, Number],
        required: true,
    },
});

const loading = ref(true);
const auditData = ref([]);

const fetchAuditData = async () => {
    try {
        const queryParams = new URLSearchParams({
            auditable: props.auditable,
            auditableId: props.auditableId,
            timestamp: Date.now()
        });

        // Agregar event solo si está definido y no es vacío
        if (props.event) {
            queryParams.append('event', props.event);
        }

        const response = await ApiService.get(`/audits?${queryParams.toString()}`);
        auditData.value = response.data.records;
    } catch (error) {
        console.error('Error al obtener auditoría:', error);
    } finally {
        loading.value = false;
    }
};


onMounted(fetchAuditData);

const getIcon = (event) => {
    switch (event) {
        case 'created': return 'pi pi-plus-circle';
        case 'updated': return 'pi pi-pencil';
        case 'deleted': return 'pi pi-trash';
        default: return 'pi pi-info-circle';
    }
};

const getColor = (event) => {
    switch (event) {
        case 'created': return '#00815B';
        case 'updated': return '#2666cc';
        case 'deleted': return '#F44336';
        default: return 'pi pi-info-circle';
    }
};

const getEventText = (event) => {
    switch (event) {
        case 'created': return $t('created');
        case 'updated': return $t('updated');
        case 'deleted': return $t('deleted');
        default: return $t('event');
    }
};

const getStatusText = (statusId) => {
    return statusId === 1 ? $t('opened') : statusId === 2 ? $t('closed') : $t('unknown');
};
const getStatusTextIncident = (statusId) => {
    statusId = parseInt(statusId);
    switch (statusId) {
        case 1: return $t('opened');
        case 2: return $t('inProgress');
        case 3: return $t('closed');
        default: return $t('unknown');
    }
};
</script>

<style scoped>
.card {
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
